
<nz-select nzShowSearch *ngIf="sharedService.facilitiesList$ | async" [(ngModel)]="selectedValue" [compareWith]="compareNzFn" (ngModelChange)="setFacility($event)" nzPlaceHolder="{{'SHARED.SELECT' | transloco}}">
  <nz-option *ngFor="let option of (sharedService.facilitiesList$ | async)" [nzValue]="option" [nzLabel]="option.facilityName"></nz-option>
</nz-select>
